import { useState } from "react";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useCookies } from "react-cookie";
import axios from "axios";
import { toast } from "react-toastify";
import * as Constants from "../../constants/urls";
import Loading from "../Loading/Loading";

export default function Sync() {
    const [groupId, setGroupId] = useState("")
    const [loading, setLoading] = useState(false)
    const [cookies, setCookie, removeCookie] = useCookies();

    function syncAll() {
        setLoading(true);
        const url =  Constants.shopApiUrl + "/api/redis/group/sync";
        axios.post(
            url,
            { password:"S3mbe!a#1999Xsk" },
            {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            },
        )
            .then((r) => {
                toast.success("عملیات با موفقیت در صف اجرا قرار گرفت")
                setLoading(false);
            })
            .catch((e) => {
                toast.error("خطا در اجرای عملیات")
                setLoading(false);
            });
    }

    function syncOnce() {
        setLoading(true);

        const url = Constants.apiUrl + "/api/sync/group/once";
        axios.post(
            url,
            { groupId: groupId },
            {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            },
        )
            .then((r) => {
                toast.success("بروزرسانی با موفقیت انجام شد")
                setLoading(false);
            })
            .catch((e) => {
                toast.error("خطا در اجرای عملیات")
                setLoading(false);
            });
    }
    function syncProduct() {
        setLoading(true);

        const url =  Constants.shopApiUrl + "/api/redis/product/sync";
        axios.post(
            url,
            { password:"S3mbe!a#1999Xsk" },
            {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            },
        )
            .then((r) => {
                toast.success("عملیات با موفقیت در صف اجرا قرار گرفت")
                setLoading(false);
            })
            .catch((e) => {
                toast.error("خطا در اجرای عملیات")
                setLoading(false);
            });
    }
    return (<>
    {
        loading?<Loading />:""
    }
        <Breadcrumb title={"همگام‌ سازی"} />
        <div className="container text-right" style={{ direction: "rtl", minHeight: "80vh" }}>
            <div className="my-2 border p-2 rounded" style={{ background: "linear-gradient(270deg, rgb(222, 238, 239) 0%, rgba(222, 238, 239, 0) 89.58%)" }}>
                <div className="my-1">بروزرسانی دیتا های محصول گروهی</div>
                <div className="btn btn-success mt-4" onClick={syncAll}>
                    بروزرسانی
                </div>
            </div>
            <hr />
             
            <div className="my-2 border p-2 rounded" style={{ background: "linear-gradient(270deg, rgb(222, 238, 239) 0%, rgba(222, 238, 239, 0) 89.58%)" }}>
                <div className="my-1">  بروزرسانی دیتا های محصول  </div>
                 <div className="btn btn-success mt-4" onClick={syncProduct}>
                    بروزرسانی
                </div>
            </div>
        </div>
    </>)

}